export default __webpack_public_path__ + "static/media/052-coin.77870583.svg";